const lightbox = document.querySelector('.c-lightbox');
const lightboxTriggers = [...document.querySelectorAll('a[href*="lightbox')];
const halfWayDown = document.documentElement.scrollHeight / 2;
let latestKnownScrollY = 0;
let ticking = false;
let cookieState;

/**
 * Toolkit functions
 */

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

/**
 * Scroll checks for auto lightbox
 */

function update() {
  ticking = false;

  if (latestKnownScrollY >= halfWayDown) {
    if (!cookieState && lightbox) {
      lightbox.classList.add('c-lightbox--active');
    }
  }
}

function requestTick() {
  if (!ticking) {
    requestAnimationFrame(update);
  }
  ticking = true;
}

function onScroll() {
  latestKnownScrollY = window.scrollY; // No IE8
  requestTick();
}

/**
 * Init the lightbox
 */

lightboxTriggers.forEach(element => {
  element.addEventListener('click', e => {
    e.preventDefault();

    const currLightboxClass = element.getAttribute('href').replace('#', '');
    const currLightboxEl = document.querySelector(`.c-${currLightboxClass}`);

    if (currLightboxEl) {
      currLightboxEl.classList.toggle('c-lightbox--active');
    }

    // Prevent lightbox auto open
    if (element.classList.contains('preventautolightbox')) {
      setCookie('preventautolightbox', true, 365);
      window.removeEventListener('scroll', onScroll);
    }
  });
});

if (!getCookie('preventautolightbox')) {
  window.addEventListener('scroll', onScroll, false);
}



// WEBPACK FOOTER //
// ./src/scripts/modules/lightbox.js